<template>
  <div class="flex flex-shrink-0">
    <Button
      v-if="!includes(activeViewControls, 'search')"
      size="xs"
      variant="tertiary"
      type="gray"
      data-id="header.search"
      :label="t('components.buttons.search')"
      :disabled="loading"
      @click="emit('toggle', 'search')"
    >
      <template #start>
        <Icon name="search" />
      </template>
    </Button>
    <Tooltip
      :title="$t('components.tooltips.filter')"
      side="bottom"
      disableHoverableContent
      v-if="showFilter"
    >
      <Button
        icon
        size="xs"
        variant="tertiary"
        type="gray"
        :disabled="loading"
        :class="{
          'bg-utility-brand-50_alt fg-brand-primary_alt': hasFilters,
        }"
        data-id="header.filter"
        @click="emit('toggle', 'filter')"
      >
        <template #start>
          <Icon name="filter-lines" />
        </template>
      </Button>
    </Tooltip>
    <div
      id="column-picker"
      class="grow flex"
      :class="{
        'pointer-events-none': loading,
      }"
    >
      <ViewSort v-if="viewType !== 'table'" :disabled="loading" :type="type" />
    </div>
  </div>
</template>

<script setup>
// Import Vue Utilities
import { Icon } from "@/SharedComponents/Icon";
import { Button } from "@/SharedComponents/Buttons";
import { ViewSort } from "@/SharedComponents/PageHeader/Partials";
import { Tooltip } from "@/SharedComponents/Tooltips";

// Import Utilities
import { useI18n } from "vue-i18n";
import { includes, isEmpty } from "lodash";
import { storeToRefs } from "pinia";
import { computed } from "vue";

// Import Composables
import { useViewControls } from "@/Composables/useViewControls";
import { useFilters } from "@/Composables/useFilters";

// View Controls: Global
const viewControlsStore = useViewControls("viewControls");
const { loading } = storeToRefs(viewControlsStore);

// Translations
const { t } = useI18n();

// Emits
const emit = defineEmits("toggle");

// Define Props
const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  viewType: {
    type: String,
    required: true,
  },
  activeViewControls: {
    type: Array,
    required: true,
  },
});

// check if any filter is active
const filterStore = useFilters(props.type || "global");
const { filterStates } = storeToRefs(filterStore);

const hasFilters = computed(() => {
  for (let filter of Object.values(filterStates.value)) {
    if (!isEmpty(filter)) {
      return true;
    }
  }
  return includes(props.activeViewControls, "filter");
});

const showFilter = computed(() => {
  if (props.type === "asset_groups" || props.type === "spaces") {
    return false;
  }

  return true;
});
</script>
